import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { faClock, faPalletAlt, faStore, faThermometerHalf, faWeightHanging } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { HeadingItem } from 'components';
import { TripContext } from 'contexts';
import dateFormat from "dateformat";
import React, { FC, ReactNode, useContext } from 'react';
import { Company, Order, Stop } from 'services/types';
import './order-card.scss';

type Props = {
    orderId?: number,
    order?: Order,
}

export const OrderCard: FC<Props> = ({ orderId, order }) => {

    const tripContext = useContext(TripContext)

    const orderData: Order = order ?? tripContext.orders.find(order => order.id === orderId) ?? {} as Order
    const stop: Stop = tripContext.stops.find(stop => stop.id === orderData.stopId) ?? {} as Stop
    const company: Company = tripContext.companies.find(company => company.id === stop.companyId) ?? {} as Company

    const appointmentFormatted = stop.appointmentTime && dateFormat(stop.appointmentTime, 'mm/dd HH:MM');
    const iconColor = '#0066A4'

    const renderTemperature = (): ReactNode => {
        return (
            <div className={'order-card-temperature'}>
                <FontAwesomeIcon icon={faThermometerHalf as IconProp} color='Red' size='1x' />
                <div>{orderData.temperature}</div>
            </div>
        )
    }

    return (
        <div className={'card-material'}>
            <HeadingItem
                text={orderData.id ? `Order: ${orderData.orderNumber?.length > 0 ? orderData.orderNumber : 'Unknown'}` : `Loading...`}
                rightHandRender={renderTemperature}
            />
            {stop.id != null &&
                <div>
                    <div className={'order-card-detail-item'}>
                        <div className={'order-card-detail-item-icon'}>
                            <FontAwesomeIcon icon={faStore as IconProp} size={'lg'} color={iconColor} />
                        </div>
                        <div className={'order-card-detail-item-info'}>{company.name}</div>
                    </div>
                    <div className={'order-card-detail-item'}>
                        <div className={'order-card-detail-item-icon'}>
                            <FontAwesomeIcon icon={faClock as IconProp} size={'lg'} color={iconColor} />
                        </div>
                        <div className={'order-card-detail-item-info'}>{appointmentFormatted}</div>
                    </div>
                </div>
            }
            {orderData.id != null &&
                <div>
                    <div className={'order-card-detail-item'}>
                        <div className={'order-card-detail-item-icon'}>
                            <FontAwesomeIcon className={'order-card-detail-item-icon'} icon={faPalletAlt as IconProp} size={'lg'} color={iconColor} />
                        </div>
                        <div className={'order-card-detail-item-info'}>{orderData.orderType}</div>
                    </div>
                    <div className={'order-card-detail-item'}>
                        <div className={'order-card-detail-item-icon'}>
                            <FontAwesomeIcon className={'order-card-detail-item-icon'} icon={faWeightHanging as IconProp} size={'lg'} color={iconColor} />
                        </div>
                        <div className={'order-card-detail-item-info'}>{orderData.totalWeight} lbs</div>
                    </div>
                </div>
            }
        </div>
    )
}
